import './pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.LocationPieChartView extends Monitoring.Views.Charts.PieChartView
  title: "User's location"
  title_en: "User's location"

  initialize: (@options = {}) ->
    super(@options)
    @name = 'location'

  afterAppend: ->
    if @data
      super
    else
      @ajaxCall('/monitoring/dashboard/charts/location', @searchQuery.toJSON(), (response) =>
        @data = response
        super
      )
    return this

  getPieData: (name) ->
    return _.collect(@data.values, (value) ->
      [value.term, value.count]
    )

  getNewQuery: (event) ->
    name = event.point.code || event.point.name
    query = @searchQuery.deepCopy()
    query.set('locations', [name])
    return query
